import { yup, yupResolver } from '@sahinyazilim/sahinyazilim-components';

export const SliderFormYup = yupResolver<any>(
  yup
    .object({
      url: yup.string().optional().max(240),
      image: yup.string().min(5).max(240).optional(),
    })
    .required(),
);
